import { Mail, Hash, User, CreditCard, Map, Trash2 } from 'lucide-react';

const Card = ({ user, handleEdit, handleDelete }) => {
    const {
        _id = 'Asdasd',
        email = 'user@example.com',
        attemptsCount = 0,
        role = 'User',
        subscription = 'Free',
        roadMapsCreatedCount = 0,
        name = 'ashwin',
    } = user;

    return (
        <div className="card bg-base-100 shadow-xl border border-base-300 w-full max-w-sm hover:shadow-2xl transition-shadow duration-300">
            <div className="card-body p-6">
                {/* Header with User Avatar */}
                <div className="flex items-center gap-3 mb-6">
                    <div className="flex-1 min-w-0">
                        <h3 className="font-semibold text-base-content truncate">
                            {name}
                        </h3>
                        <p className="text-sm text-base-content/60 truncate">
                            {email}
                        </p>
                    </div>
                </div>

                {/* Stats Grid */}
                <div className="grid grid-cols-2 gap-4 mb-6">
                    {/* Attempts */}
                    <div className="bg-base-200 rounded-lg p-3 text-center">
                        <Hash className="w-5 h-5 text-secondary mx-auto mb-1" />
                        <div className="text-2xl font-bold text-base-content">
                            {attemptsCount}
                        </div>
                        <div className="text-xs text-base-content/60">
                            Attempts
                        </div>
                    </div>

                    {/* Roadmaps */}
                    <div className="bg-base-200 rounded-lg p-3 text-center">
                        <Map className="w-5 h-5 text-success mx-auto mb-1" />
                        <div className="text-2xl font-bold text-base-content">
                            {roadMapsCreatedCount}
                        </div>
                        <div className="text-xs text-base-content/60">
                            Roadmaps
                        </div>
                    </div>
                </div>

                {/* Role and Subscription Badges */}
                <div className="flex flex-col gap-3 mb-6">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <User className="w-4 h-4 text-accent" />
                            <span className="text-sm text-base-content/70">
                                Role
                            </span>
                        </div>
                        <div
                            className={`badge ${role === 'superAdmin' ? 'badge-error' : role === 'admin' ? 'badge-warning' : 'badge-neutral'}`}
                        >
                            {role}
                        </div>
                    </div>

                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <CreditCard className="w-4 h-4 text-info" />
                            <span className="text-sm text-base-content/70">
                                Plan
                            </span>
                        </div>
                        <div
                            className={`badge ${subscription === 'premiumPlus' ? 'badge-success' : subscription === 'premium' ? 'badge-warning' : 'badge-ghost'}`}
                        >
                            {subscription}
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="card-actions flex flex-col gap-2">
                    <button
                        className="btn btn-primary btn-sm w-full"
                        onClick={() => handleEdit(user)}
                    >
                        <User className="w-4 h-4" />
                        Manage User
                    </button>

                    {/* Only show delete button for non-admin users */}
                    {role !== 'superAdmin' && role !== 'admin' && (
                        <button
                            className="btn btn-error btn-outline btn-sm w-full"
                            onClick={() => handleDelete(user._id)}
                        >
                            <Trash2 className="w-4 h-4" />
                            Delete User
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Card;
